import React from 'react';
import { Edit, SimpleForm, TextInput, ShowButton, NullableBooleanInput, required, regex } from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import CustomLabelInput from '../components/CustomLabelInput';
import ContactIcon from '@material-ui/icons/PermPhoneMsg';

function phoneNumberFormat(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    } else if (phoneNumberString.length >= 14) {
        return phoneNumberString.substring(0, 14)
    } else {
        return phoneNumberString.substring(0, 14)
    }
}

const InspectorEditActions = (props) => {
    const { basePath } = props;
    return (
        <CardActions>
            <BackButton style={{ marginRight: "auto" }}></BackButton>
            <ShowButton basePath={basePath} record={props.data} />
        </CardActions>
    );
};

const InspectorEditGeneral = ({ record }) => {
    return (
        <div className="row mb-3 mb-md-0">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row">
                    <div className="my-0 py-0 col-12 col-md-8">
                        <TextInput source="display_name" label={<CustomLabelInput label="Name" />} fullWidth variant="outlined" validate={required()} />
                    </div>
                    <div className="my-0 py-0 col">
                        <NullableBooleanInput label={<CustomLabelInput label="Active" />} source="active" fullWidth variant="outlined" validate={required()} />
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 px-4 pt-1">
                <InspectorEditNotes record={record} />
            </div>
        </div>
    );
};

const InspectorEditNotes = ({ record }) => {
    return (
        <div className="row row-cols-1 py-0 m-0">
            <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                <RichTextInput source="notes" label="Notes" stripTags emptyText="Notes" />
            </div>
        </div>
    );
};

const InspectorEditContact = ({ record }) => {
    return (
        <div className="row row-cols-3 g-2 g-lg-3">
            <div>
                <TextInput source="phone" placeholder="(000) 000-0000" className="w-100" validate={regex(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, 'Must be (000) 000-0000')} parse={phoneNumberFormat} label={<CustomLabelInput label="Phone"/>} fullWidth variant="outlined" resettable />
            </div>
            <div>
                <TextInput source="email" className="w-100" label={<CustomLabelInput label="Email" />} variant="outlined" />
            </div>
        </div>
    );
};

const InspectorEdit = (props) => {
    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Edit Inspector</h3>
            <Edit className="m-0 p-0" title=" " actions={<InspectorEditActions />} {...props}>
                <SimpleForm redirect="show">
                    <InspectorEditGeneral className="mb-3" record={{ ...props }} />

                    <h6 className="font-weight-normal pt-2">{<ContactIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Contact</h6>
                    <InspectorEditContact record={{ ...props }} />
                </SimpleForm>
            </Edit>
        </>
    )
};

export default InspectorEdit;
